import React, { useState, useEffect } from "react";
import fbads from "../images/ads fb.jpg";

export default function AutoPopup() {

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => setOpen(false);

  return (
    <>
      {open && (
        <div className="popup-overlay">

          <div className="popup-box">

            {/* Close Icon */}
            <span className="popup-close" onClick={closePopup}>
              ×
            </span>

            <div className="popup-content">

                <a href="ListYourProperty">
              <img src={fbads} className="card-img-top" alt="fbads" />
              </a>


              <button className="popup-btn" onClick={closePopup}>
                Close
              </button>

            </div>

          </div>

        </div>
      )}
    </>
  );
}